import { api } from 'common';

import { BlockTextField } from '../../ConfigFields/TextField';
import { type BlockConfigProps } from '../../types';

function FormFields() {
  return (
    <BlockTextField
      fieldName="config.orderId"
      label="Test patientOrderId (leave empty to use provided entity)"
      helperText="Extract a patient order using the patientOrderID."
    />
  );
}

const documentationMarkdown = `
# Get Patient Order

Retrieve the full patient order record from the Notable database for the order with the specified id
`;

export const getPatientOrderConfig: BlockConfigProps<api.FlowDefinition.GetPatientOrderBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'patientOrder',
    defaultConfig: {
      orderId: '',
    },
    configFields: {
      schema: api.FlowDefinition.GetPatientOrderBlockConfigSchema,
      FormFields,
    },
    documentationMarkdown,
  };
